import { createGoToHome } from './createGoToHome';
import { createOpenFlightSummary } from './createOpenFlightSummary';
export const goToHome = createGoToHome(window.Odigeo);
export const openFlightSummary = createOpenFlightSummary(window.Odigeo);